(function () {
  function normalize(value) {
    return (value || "").toString().trim().toLowerCase();
  }

  function prefixFromTitle(title) {
    var t = normalize(title);
    if (!t) return "";
    if (t.indexOf("pro") !== -1) return "pro--";
    if (t === "abxcore" || t.indexOf("standard") !== -1) return "standard--";
    return "";
  }

  function selectedTitle() {
    var radio = document.querySelector(
      "variant-radios input[type='radio']:checked, variant-selects input[type='radio']:checked, .product-form__input input[type='radio']:checked"
    );
    if (radio && radio.value) return radio.value;

    var option = document.querySelector("variant-selects select option:checked, select[name='id'] option:checked");
    if (option && option.textContent) return option.textContent;

    return "";
  }

  function visibleSlides(root) {
    return Array.prototype.filter.call(root.querySelectorAll(".product__media-item"), function (item) {
      return !item.classList.contains("abx-variant-hidden");
    });
  }

  function currentIndex(list, slides) {
    var left = list.getBoundingClientRect().left;
    var best = 0;
    var bestDelta = Infinity;
    slides.forEach(function (slide, i) {
      var delta = Math.abs(slide.getBoundingClientRect().left - left);
      if (delta < bestDelta) {
        bestDelta = delta;
        best = i;
      }
    });
    return best;
  }

  function goToSlide(list, slide, behavior) {
    if (!list || !slide) return;
    var left = slide.offsetLeft;
    if (typeof list.scrollTo === "function") {
      list.scrollTo({ left: left, behavior: behavior || "smooth" });
    } else {
      list.scrollLeft = left;
    }
  }


  function patchSlider(sc) {
    if (!sc || sc.classList.contains("thumbnail-slider") || sc.__abxPatched) return;
    sc.__abxPatched = true;
    sc.resetPages = function () {
      this.sliderItems = this.querySelectorAll(".product__media-item:not(.abx-variant-hidden)");
      this.initPages();
      if (!this.slidesPerPage || this.slidesPerPage < 1) {
        this.slidesPerPage = 1;
        this.totalPages = (this.sliderItemsToShow && this.sliderItemsToShow.length) || visibleSlides(this).length;
      }
      if (typeof this.update === "function") this.update();
    };
  }

  function filterGallery() {
    var prefix = prefixFromTitle(selectedTitle());
    var items = document.querySelectorAll(
      ".product__media-wrapper .product__media-item, .thumbnail-list__item"
    );

    items.forEach(function (item) {
      var img = item.querySelector("img");
      var alt = normalize(img && img.getAttribute("alt"));
      var tagged = alt.indexOf("pro--") === 0 || alt.indexOf("standard--") === 0;
      var hide = Boolean(prefix && tagged && alt.indexOf(prefix) !== 0);

      item.classList.toggle("abx-variant-hidden", hide);
      if (hide) {
        item.style.setProperty("display", "none", "important");
      } else {
        item.style.removeProperty("display");
      }
    });

    document.querySelectorAll(".product__media-wrapper slider-component").forEach(function (sc) {
      patchSlider(sc);
      if (typeof sc.resetPages === "function") sc.resetPages();
      var list = sc.querySelector(".product__media-list") || sc.slider;
      var first = visibleSlides(sc)[0];
      if (list && first) goToSlide(list, first, "auto");
    });
  }

  function onArrowClick(event) {
    var button = event.target.closest(".slider-button");
    if (!button) return;
    var sc = button.closest("slider-component");
    if (!sc || sc.classList.contains("thumbnail-slider")) return;
    if (!sc.closest(".product__media-wrapper")) return;

    event.preventDefault();
    event.stopPropagation();

    var list = sc.querySelector(".product__media-list") || sc.slider;
    var slides = visibleSlides(sc);
    if (!list || slides.length < 2) return;

    var index = currentIndex(list, slides);
    var nextIndex = button.classList.contains("slider-button--next") || button.name === "next"
      ? Math.min(slides.length - 1, index + 1)
      : Math.max(0, index - 1);

    goToSlide(list, slides[nextIndex], "smooth");
  }

  function bind() {
    document.addEventListener("change", function (event) {
      if (
        event.target.closest("variant-radios") ||
        event.target.closest("variant-selects") ||
        event.target.name === "id" ||
        event.target.name === "Model"
      ) {
        window.setTimeout(filterGallery, 40);
      }
    });

    document.addEventListener("variantChange", function () {
      window.setTimeout(filterGallery, 40);
    });
    document.addEventListener("variant:change", function () {
      window.setTimeout(filterGallery, 40);
    });

    document.addEventListener("click", onArrowClick, true);
    filterGallery();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }
})();
